export const ACH= "ACH";
export const BTN_RESEND_ACCESS_CODE = "Resend Access Code";
export const AUTHENTICATION_ACCESS_CODE_RECEIVE =
  "Did not receive the access code?";
export const AUTHENTICATION_ACCESS_CODE_INVALIDATED =
	"Resending will invalidate the previous code; use the latest one.";
export const AUTHENTICATION_ACCESS_CODE_RESEND_TIME = "Resend available in";
